import React from 'react';
import {Link} from 'react-router-dom';
import {isEmpty} from 'lodash';
import logoBlue from 'assets/images/static/logo-blue.png';

import styles from './styles.module.scss';
import LeadGenerationLogo from './lead-generation-logo/lead-genreation-logo';
import useFeatureFlags from 'src/hooks/useFeatureFlags';

interface NavbarLogoProps {
  homePath?: string;
  routed?: boolean;
  experienceEverywhere?: boolean;
}

const NavbarLogo = ({homePath = '/', routed, experienceEverywhere = false}: NavbarLogoProps) => {
  const flags = useFeatureFlags(['leadGenerationLogoFlag']);

  if (experienceEverywhere && isEmpty(flags)) {
    return null;
  }

  if (experienceEverywhere && flags.leadGenerationLogoFlag) {
    return <LeadGenerationLogo experienceEverywhere={experienceEverywhere} />;
  }

  const logo = <img width="118" src={logoBlue} alt="Go to Raise Me homepage" />;

  return routed ? (
    <Link to={homePath} className={styles.logo}>
      {logo}
    </Link>
  ) : (
    <a href={homePath} className={styles.logo}>
      {logo}
    </a>
  );
};

export default NavbarLogo;
